<template>
  <div class="report-15" dir="rtl">
    <div style="margin-top: 200px;" v-if="pathLogo == m "></div>

    <section class="header">
      <h5 class="">{{ name }}</h5>
      <div class="left">
        <h5 class="text-left" style="margin-left: 50px; direction: ltr">
          التاريخ : {{ date }}
        </h5>
        <div>
          <p>الشهر : 01</p>
          <p>السنة : 01</p>
          <p>عدد الموظفين : 01</p>
          <p>عدد الرواتب : 01</p>
        </div>
      </div>
    </section>
    <section class="body">
      <div style="text-align: center;">
        <img  class="wlogo" :src="pathLogo" />
       </div>
      <h4>الكشف التحليلى العام</h4>
      <div class="first-section">
        <div class="right">
          <div class="t-head">
            <p>المرتب الأساسى</p>
            <p>العلاوات</p>
            <p>الإجمالى</p>
          </div>
          <div class="t-body">
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>
        <div class="left">
          <div class="t-head">
            <p>الضمان</p>
            <p>التضامن</p>
            <p>الجهاد</p>
            <p>ضريبة الدخل</p>
            <p>خصم الدينار</p>
            <p>غياب</p>
            <p>مجموع الخصميات</p>
            <p>الصافى</p>
          </div>
          <div class="t-body">
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
            <p></p>
          </div>
        </div>
      </div>
      <div class="second-section">
        <div class="right">
          <div class="t-head">
            <p>علاوات ومستحقات أخرى</p>
            <p>الإجمالى</p>
          </div>
          <div class="t-body">
            <p>test</p>
            <p>test</p>
            <p>test</p>
          </div>
          <div class="t-body">
            <p>test</p>
            <p>test</p>
            <p>test</p>
          </div>
        </div>
        <div class="left">
          <div class="t-head">
            <div class="t-head-r">
              <p>خصميات أخرى</p>
              <p>القسط الشهرى صندوق التكافل</p>
              <p>القسط الشهرى لسلفة صندوق التكافل</p>
            </div>
            <div class="t-head-l">
              <p>one</p>
              <p>one</p>
              <p>one</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
 import env from "../../../env";

export default {
  props: ["month", "date", "name", "desc","pathLogo"],
  data() {
    return {
      m:env.mTop(),

    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/report-15";
</style>
